export default function getResource(label, vars = []) {
    const resources = {
        brandLink: 'Découvrir cette marque'
    };
    return resources[label];
}
